import Checkbox from '@/components/@IntranetLibrary/Checkbox';
import {
  CheckLabel,
  Divider,
  Wrapper,
} from '@/components/Approval/@components/NoReadButton/styles';

type P = {
  title: string;
  isChecked: boolean;
  onChange: () => void;
};

const NoReadButton = ({ title, isChecked, onChange }: P) => {
  return (
    <Wrapper>
      <Divider />
      <CheckLabel
        className={'v2cb-hover-target'}
        control={
          <Checkbox
            checked={isChecked}
            onChange={onChange}
            sx={{ padding: 0 }}
          />
        }
        label={title}
      />
    </Wrapper>
  );
};

export default NoReadButton;
